var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 153,
    viewBox: "0 0 140 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8381 152.28H47.8301L47.8301 104.732H56.8381C63.1434 104.732 69.1904 107.237 73.6488 111.695C78.1073 116.154 80.612 122.201 80.612 128.506C80.612 131.628 79.9971 134.72 78.8024 137.604C77.6076 140.488 75.8564 143.109 73.6488 145.317C71.4412 147.524 68.8204 149.276 65.936 150.47C63.0516 151.665 59.9602 152.28 56.8381 152.28Z",
    fill: "url(#paint0_linear_2166_493)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0536 33.0426C33.1087 33.0426 40.4494 25.7019 40.4494 16.6468C40.4494 7.59172 33.1087 0.251099 24.0536 0.251099C14.9985 0.251099 7.6579 7.59172 7.6579 16.6468C7.6579 25.7019 14.9985 33.0426 24.0536 33.0426Z",
    fill: "url(#paint1_linear_2166_493)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.278015 67.7321V105.375C0.277806 111.535 1.49087 117.634 3.84799 123.325C6.20512 129.016 9.66011 134.187 14.0157 138.542C18.3713 142.898 23.5421 146.353 29.233 148.71C34.9239 151.067 41.0233 152.28 47.183 152.28H56.8392C57.5 152.28 58.1566 152.253 58.8029 152.198C55.3599 149.286 52.5942 145.657 50.6989 141.565C48.8035 137.473 47.8242 133.016 47.8293 128.506V67.7321C47.8293 61.4265 45.3243 55.379 40.8655 50.9203C36.4068 46.4615 30.3594 43.9565 24.0537 43.9565C17.748 43.9565 11.7006 46.4615 7.24179 50.9203C2.783 55.379 0.278015 61.4265 0.278015 67.7321Z",
    fill: "#2D9BFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5954 43.9563H91.6034V91.5042H82.5954C76.2902 91.5042 70.2432 88.9994 65.7847 84.5409C61.3263 80.0825 58.8215 74.0355 58.8215 67.7303C58.8215 64.6082 59.4364 61.5167 60.6312 58.6324C61.8259 55.748 63.5771 53.1271 65.7847 50.9195C67.9923 48.7119 70.6131 46.9607 73.4975 45.766C76.3819 44.5712 79.4734 43.9563 82.5954 43.9563Z",
    fill: "url(#paint2_linear_2166_493)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.155 128.504V90.8616C139.156 84.7019 137.943 78.6024 135.585 72.9116C133.228 67.2207 129.773 62.0499 125.418 57.6943C121.062 53.3388 115.891 49.8838 110.201 47.5267C104.51 45.1695 98.4102 43.9565 92.2505 43.9567H82.5944C81.9336 43.9567 81.2769 43.9838 80.6306 44.038C84.0736 46.9506 86.8393 50.5797 88.7347 54.6718C90.6301 58.7639 91.6094 63.2204 91.6043 67.7301V128.504C91.6043 134.81 94.1092 140.857 98.568 145.316C103.027 149.775 109.074 152.28 115.38 152.28C121.686 152.28 127.733 149.775 132.192 145.316C136.651 140.857 139.155 134.81 139.155 128.504Z",
    fill: "url(#paint3_linear_2166_493)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2166_493",
    x1: 80.612,
    y1: 128.506,
    x2: 44.9483,
    y2: 128.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08584,
    stopColor: "#F7FBFF",
    stopOpacity: 0.03899
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23095,
    stopColor: "#E1F1FF",
    stopOpacity: 0.1442
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41769,
    stopColor: "#BDDFFE",
    stopOpacity: 0.31549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63876,
    stopColor: "#8BC8FD",
    stopOpacity: 0.55306
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88592,
    stopColor: "#4CAAFC",
    stopOpacity: 0.85209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9BFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2166_493",
    x1: 24.0536,
    y1: -0.136341,
    x2: 24.0536,
    y2: 34.4633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D9BFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28CCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2166_493",
    x1: 58.8215,
    y1: 67.7302,
    x2: 94.4852,
    y2: 67.7302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08905,
    stopColor: "#F6FDFE",
    stopOpacity: 0.04093
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23959,
    stopColor: "#DEF7FD",
    stopOpacity: 0.15136
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43325,
    stopColor: "#B8EEFA",
    stopOpacity: 0.33111
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66249,
    stopColor: "#82E1F6",
    stopOpacity: 0.58037
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91897,
    stopColor: "#3FD1F2",
    stopOpacity: 0.89435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28CCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2166_493",
    x1: 109.459,
    y1: 47.5885,
    x2: 111.766,
    y2: 151.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29EFDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.10c820b3b626578c411b512aa0c208af.svg";
export { ForwardRef as ReactComponent };